export function toLocalizedDate(
  dateInUtc: Date | string | undefined | null,
  locale: string
): string | null {
  if (!dateInUtc) {
    return null
  }
  let date: Date
  if (typeof dateInUtc === 'string') {
    date = new Date(dateInUtc)
  } else {
    date = dateInUtc
  }
  return date.toLocaleDateString(locale === 'de' ? 'de-DE' : 'en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}
